import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';


export default function HorizontalSectionCard({
            title, blurb, primaryButtonRow, imageDirection, imageBackgroundGridOff,
            primaryImageURL, primaryImageALT,primaryImageShouldMaxHeight,
            secondaryImageURL, secondaryImageALT, secondaryImageShouldMaxHeight,
            shouldShowHighlight, animationStyle="slide"
}) {

// ... inside your component

    const containerRef = useRef(null);
    const isInView = useInView(containerRef, { once: true, margin: "-100px" });

// Define animation variants based on style
    const getVariants = (style, isImage) => {
        switch (style) {
            case 'slide':
                return {
                    hidden: { opacity: 0, x: isImage ? -50 : 50 },
                    visible: {
                        opacity: 1,
                        x: 0,
                        transition: { duration: 0.6, ease: 'easeOut', delay: isImage ? 0 : 0.1 }
                    }
                };
            case 'fadeUp':
                return {
                    hidden: { opacity: 0, y: 40 },
                    visible: { opacity: 1, y: 0, transition: { duration: 1.6, ease: 'easeOut' } },
                }
            case 'fade':
                return {
                    hidden: { opacity: 0, scale: 0.95 },
                    visible: {
                        opacity: 1,
                        scale: 1,
                        transition: { duration: 0.7, ease: 'easeOut', delay: 0.1 }
                    }
                };
            case 'zoom':
                return {
                    hidden: { opacity: 0, scale: 0.9 },
                    visible: {
                        opacity: 1,
                        scale: 1,
                        transition: { duration: 0.5, ease: 'easeOut' }
                    }
                };
            case 'blur':
                return {
                    hidden: { opacity: 0, filter: 'blur(8px)' },
                    visible: {
                        opacity: 1,
                        filter: 'blur(0px)',
                        transition: { duration: 0.6, ease: 'easeOut' }
                    }
                };
            case 'rotate':
                return {
                    hidden: { opacity: 0, rotate: -10, scale: 0.9 },
                    visible: {
                        opacity: 1,
                        rotate: 0,
                        scale: 1,
                        transition: { duration: 0.6, ease: 'easeOut' }
                    }
                };
            case 'flip':
                return {
                    hidden: { opacity: 0, rotateX: 90 },
                    visible: {
                        opacity: 1,
                        rotateX: 0,
                        transition: { duration: 0.6, ease: 'easeOut' }
                    }
                };
            case 'bounce':
                return {
                    hidden: { opacity: 0, y: 30 },
                    visible: {
                        opacity: 1,
                        y: 0,
                        transition: { type: 'spring', stiffness: 300, damping: 15, delay: 0.1 }
                    }
                };
            case 'drop':
                return {
                    hidden: { opacity: 0, y: -100 },
                    visible: {
                        opacity: 1,
                        y: 0,
                        transition: { type: 'spring', stiffness: 500, damping: 20, delay: 0.1 }
                    }
                };
            case 'scale':
                return {
                    hidden: { opacity: 0, scale: 0.6 },
                    visible: {
                        opacity: 1,
                        scale: 1,
                        transition: { duration: 0.5, ease: 'easeOut' }
                    }
                };
            default:
                return {
                    hidden: { opacity: 1, x: 0, scale: 1 },
                    visible: { opacity: 1, x: 0, scale: 1 }
                };
        }
    };

// Use these variants in the motion components
    const imageVariants = getVariants(animationStyle, true);
    const contentVariants = getVariants(animationStyle, false);

    return (
        <div
            ref={containerRef}
            className={shouldShowHighlight ? "md:mx-12 md:px-12 py-8" : ""}
            style={{
                boxShadow: shouldShowHighlight ? "0px 0px 30px 10px rgba(205, 175, 75, 0.4)" : "none",
            }}
        >
            <div className="theme-dark bg-color _none bg-pattern">
                <div className="container">
                    <div className="layout row no-gutters layout-builder__layout">
                        <div className="col-12">
                            <div className="_none block block-layout-builder block-inline-blockixm-blocks-ping-pong block-ping-pong py-5 py-lg-6">
                                <div className="container">
                                    <div
                                        className="sas-ping-pong-item position-relative align-items-center justify-content-center"
                                        id="ping-pong-inline_block:ixm_blocks_ping_pong-ping-pong-item-1"
                                    >
                                        <div className="row g-5 g-lg-7">
                                            {imageDirection === "left" && (
                                                <motion.div
                                                    className="col-12 col-lg sas-ping-pong-media-tab position-relative"
                                                    variants={imageVariants}
                                                    initial="hidden"
                                                    animate={isInView ? "visible" : "hidden"}
                                                >
                                                    {imageSection()}
                                                </motion.div>
                                            )}

                                            <motion.div
                                                className="col-12 col-lg sas-ping-pong-content-tab position-relative d-flex align-items-center"
                                                variants={contentVariants}
                                                initial="hidden"
                                                animate={isInView ? "visible" : "hidden"}
                                            >
                                                <div className="sas-ping-pong-content space-y-4">
                                                    <div className="row">
                                                        <div className="col align-self-end">
                                                            <h2 className="fw-normal" style={{ fontSize: "clamp(1.5rem, 4vw, 3.75rem)" }}>{title}</h2>
                                                        </div>
                                                    </div>
                                                    <p>
                                                        <meta charSet="utf-8" />
                                                        <span style={{ whiteSpace: 'pre-wrap' }}>{blurb}</span>
                                                    </p>
                                                    <div className="">
                                                        <div className="col flex-wrap mx-n2">{primaryButtonRow}</div>
                                                    </div>
                                                </div>
                                            </motion.div>

                                            {imageDirection !== "left" && (
                                                <motion.div
                                                    className="col-12 col-lg sas-ping-pong-media-tab position-relative"
                                                    variants={imageVariants}
                                                    initial="hidden"
                                                    animate={isInView ? "visible" : "hidden"}
                                                >
                                                    {imageSection()}
                                                </motion.div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    function imageSection() {
        return (
            <div className="col-12 col-lg sas-ping-pong-media-tab position-relative ">
                {!Boolean(imageBackgroundGridOff) &&
                    <div className="sas-ping-pong-media-tab-background w-100 h-100 position-absolute start-0 top-0">
                    </div>
                }
                <div
                    className="sas-ping-pong-primary-image polaroid image-effects__floating sas-ping-pong-primary-image-left">

                    <img
                        src={primaryImageURL}
                        className={`${primaryImageShouldMaxHeight ? "h-max" : "h-100"} w-100 object-cover`}
                        alt={primaryImageALT}/>
                </div>
                {
                    secondaryImageURL &&
                    <div
                        className="sas-ping-pong-secondary-image polaroid image-effects__floating sas-ping-pong-secondary-image-left">

                        <img
                            src={secondaryImageURL}
                            className={`${secondaryImageShouldMaxHeight ? "h-max" : "h-100"} w-100 object-cover`}
                            alt={secondaryImageALT}/>
                    </div>
                }
            </div>
        )
    }
}